import { useTranslation } from 'react-i18next';
import type { TaskCardType } from '@econtractor/types';
import SolarIcon from 'components/icons/SolarIcon';
import TaskExecutorTermForm from '../../../shared/TaskExecutorTermForm';
import TaskTermEditForm from '../../../shared/TaskTermEditForm';
import TaskTermInterval from '../../../shared/TaskTermInterval';

interface TaskCardTermSectionProps {
    task: TaskCardType;
    editingTerm: boolean;
    editingExecutorTerm: boolean;
    canEditTerm: boolean;
    canChangeExecutorTerm: boolean;
    onStartEditTerm: () => void;
    onStartEditExecutorTerm: () => void;
    onCancelTerm: () => void;
    onCancelExecutorTerm: () => void;
    onSaved: (task: TaskCardType) => void;
}

const TaskCardTermSection = ({
    task,
    editingTerm,
    editingExecutorTerm,
    canEditTerm,
    canChangeExecutorTerm,
    onStartEditTerm,
    onStartEditExecutorTerm,
    onCancelTerm,
    onCancelExecutorTerm,
    onSaved,
}: TaskCardTermSectionProps) => {
    const { t } = useTranslation(['Tasks', 'common']);

    return (
        <section className="task-card-section mb-3">
            <div className="task-card-section__label">{t('fields.term')}</div>

            {editingTerm ? (
                <div className="task-card-panel">
                    <TaskTermEditForm task={task} onCancel={onCancelTerm} onSaved={onSaved} />
                </div>
            ) : editingExecutorTerm ? (
                <div className="task-card-panel">
                    <TaskExecutorTermForm task={task} onCancel={onCancelExecutorTerm} onSaved={onSaved} />
                </div>
            ) : (
                <div className="task-card-panel">
                    <div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-end justify-content-between gap-2">
                        <div className="flex-grow-1 min-w-0">
                            <TaskTermInterval
                                taskId={task.ID}
                                dateStart={task.dateStart}
                                dateEnd={task.dateEnd}
                                taskStatus={Number(task.taskStatus)}
                                withTime={Boolean(task.withTime)}
                            />
                        </div>
                        {(canEditTerm || canChangeExecutorTerm) && (
                            <div className="text-end flex-shrink-0 d-flex flex-column align-items-end gap-1">
                                {canEditTerm && (
                                    <button
                                        type="button"
                                        className="btn btn-link p-0 align-baseline fs-12"
                                        onClick={onStartEditTerm}
                                    >
                                        <SolarIcon name="pencil" className="me-1 fs-14" />
                                        {t('common:buttons.change')}
                                    </button>
                                )}
                                {canChangeExecutorTerm && (
                                    <button
                                        type="button"
                                        className="btn btn-link p-0 align-baseline fs-12"
                                        onClick={onStartEditExecutorTerm}
                                    >
                                        <SolarIcon name="calendar-date" className="me-1 fs-14" />
                                        {t('btnChangeExecutionTerm')}
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </section>
    );
};

export default TaskCardTermSection;
